export default "<st-members-manager team=\"$ctrl.teamInfo\" user=\"$ctrl.userInfo\" roles=\"$ctrl.roleInfo\" mode=\"$ctrl.mode\"></st-members-manager>";